import { render, staticRenderFns } from "./ProjectsPreview.vue?vue&type=template&id=32b938fd&scoped=true&"
import script from "./ProjectsPreview.vue?vue&type=script&lang=js&"
export * from "./ProjectsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPreview.vue?vue&type=style&index=0&id=32b938fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b938fd",
  null
  
)

export default component.exports